import React, {useMemo} from 'react';
import styled from "styled-components";
import EventPlayer from "./EventIcon";
import {ImageLane} from "../common";
import TierTag from "../common/TierTag";
import RankingWinRate from "../Ranking/RankingContent/RankingTable/RankingTableContent/RankingWinRate";
import {romanNumberConverter, storePuuIdLocal, threedigits} from "../../function";

const Wrapper = styled.div`
  border: 1px solid ${props => {
    let border = props.theme.color.purple_500;
    if (props.status === 'Streamer') border = props.theme.color.red_800;
    return border;
  }};
  border-radius: 8px;
  width: 261px;
  height: 152px;
  overflow: hidden;
`;
const CardHeader = styled.div`
  font-size: 12px;
  font-weight: 700;
  width: 100%;
  padding: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 18px;
  color: ${props => {
    let border = props.theme.color.purple_700;
    if (props.status === 'Streamer') border = props.theme.color.pink_100;
    return border;
  }};
  background-color: ${props => {
    let border = props.theme.color.purple_600;
    if (props.status === 'Streamer') border = props.theme.color.red_900;
    return border;
  }};
`;

const Content = styled.div`
  padding: 15px 10px;
  background-color: ${props => props.theme.color.site_main_color};
`;
const PlayerCircleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;
const TeamImage = styled.img`
  margin-right: 4px;
`;
const NameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const Name = styled.span`
  color: ${props => props.theme.color.dark_100};
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
const InfoWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;

  .win-rate-text {
    padding: 2px 4px;
  }

  .win-rate-bar {
    width: 100%;
  }

  .percent {
    font-size: 9px;
    color: ${props => props.theme.color.dark_200};
    margin-left: 0;
  }
`;
const TagWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 6px;
  margin-right: 4px;
`;

const LPText = styled.span`
  color: ${props => props.theme.color.dark_100};
  font-size: 12px;
`;
const LP = styled.span`
  margin-left: 1px;
  color: ${props => props.theme.color.dark_200};
  font-size: 12px;
`;
const Bar = styled.div`
  margin: 10px 1.5px 10px 1.5px;
  flex: 1;
  height: 1px;
  background-color: ${props => props.theme.color.gray_200};
`;

const Box = styled.div`
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 12px;
  font-weight: 700;
`;
const WinLoseBox = styled(Box)`

  background-color: ${props => {
    let color = props.theme.color.blue_100
    if (props.win === 0) color = props.theme.color.red_100
    if (props.win === 9) color = props.theme.color.site_background_color
    return color
  }};
  background-image: url(${props => {
    let image = 'none';
    if (props.win === 9) image = `"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='3' ry='3' stroke='${encodeURIComponent(props.theme.color.default_border_color)}' stroke-width='2' stroke-dasharray='3%2c5' stroke-dashoffset='8' stroke-linecap='square'/%3e%3c/svg%3e"`;
    return image
  }});

  color: ${props => {
    let color = '#fff';
    if (props.win === 9) color = props.theme.color.dark_300
    return color
  }};
`;
const WinBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
`;
const Question = styled(Box)`

  color: #fff;
  background-color: ${props => props.theme.color.gray_500}
}

;
`;
const EventCard = ({
                       status,
                       nation,
                       name,
                       position,
                       tier,
                       division,
                       win,
                       lose,
                       lp,
                       live,
                       win_table,
                       tag,
                       url_name,
                       riot_id,
                       puu_id,
                       championship_name,
                       region,
                   }) => {
    const getWinLoseText = (value) => {
        if (value === 2) {
            return '?'
        }
        if (value === 1) {
            return 'W'
        }
        if (value === 0) {
            return 'L'
        }
    }
    const statusName = useMemo(() => {
        if (status === 'Streamer') {
            return 'STRM'
        }
        return 'PRO'
    }, [status]);
    return (
        <Wrapper status={status}>
            <CardHeader status={status}>
                {statusName}
            </CardHeader>
            <Content>
                <PlayerCircleWrapper>
                    <div>
                        <PlayerCircle live={live} name={name} status={status} riot_tag={tag} url_name={url_name}
                                      riot_id={riot_id} puuId={puu_id} championship_name={name}
                                      region={region}/>
                    </div>
                    <InfoWrapper>
                        <NameWrapper>
                            <TeamImage
                                key={nation + "nation"}
                                src={`${process.env.REACT_APP_ROOT_IMG}nation/${nation?.toLowerCase()}.png`}
                                width={18} height={12} alt={''}
                                onError={(e) => e.target.style.display = 'none'}
                            />
                            <Name onClick={() => storePuuIdLocal(`${riot_id}-${tag}`, region, puu_id)}>{name}</Name>
                        </NameWrapper>
                        <NameWrapper>

                            <ImageLane
                                color={'dark'}
                                lane={position}
                            />
                            <TagWrapper>
                                <TierTag
                                    fontSize={'11px'}
                                    padding={'4px 4px'}
                                    tier={tier}
                                    division={romanNumberConverter(division)}
                                />
                            </TagWrapper>

                            <LPText>
                                {threedigits(lp)}
                                <LP>
                                    LP
                                </LP>
                            </LPText>
                        </NameWrapper>
                        <RankingWinRate
                            lose={lose}
                            win={win}
                        />
                    </InfoWrapper>
                </PlayerCircleWrapper>
                <Bar/>
                <WinBox>
                    {Array.from({length: 10}).map((_, index) => {
                        const value = win_table?.[index];
                        const calcValue = (value !== 0 && value !== 1) ? 2 : value;
                        return (
                            <WinLoseBox win={calcValue} key={index}>
                                {getWinLoseText(calcValue)}
                            </WinLoseBox>
                        )
                    })}
                    <Question>
                        ?
                    </Question>
                </WinBox>
            </Content>
        </Wrapper>
    );
};


const Circle = styled.div`
  cursor: pointer;
  border-radius: 100%;
  border: 4px solid ${props => {
    let outline = props.theme.color.green_100;
    if (props.live === 1) {
      outline = '#EB5B5B';
    }
    return outline
  }};
  box-shadow: ${props => {
    let shadow = '0';
    if (props.live === 1) {
      shadow = '0px 0px 10px 0px rgba(235, 91, 91, 80%)';
    }
    return shadow
  }};
  position: relative;
  display: flex;
  justify-content: center;
`;
const LiveAbsolute = styled.div`
  position: absolute;
  top: 38px;
`;

const PlayerBox = styled.div`
  margin: 1px;
`;


const PlayerCircle = ({name, live, isRoom, puuId, riot_id, riot_tag, status, url_name, championship_name, region}) => {
    return (
        <Circle live={live}>
            <PlayerBox>
                <EventPlayer name={status === 'pro' ? championship_name : name} width={48} height={48} isRoom={isRoom}
                             puuId={puuId} riot_id={riot_id}
                             riot_tag={riot_tag} status={status} url_name={name} toSummoner={true} region={region}/>
            </PlayerBox>
            {live === 1 &&
                <LiveAbsolute>
                    <img src={'images/event/event_live.svg'} width={42} height={20} alt={''}/>
                </LiveAbsolute>}
        </Circle>
    )
}
export default EventCard;